<template>
  <div
    class="relative mx-auto min-h-80 max-w-7xl rounded-sm bg-white p-3 shadow-md"
    data-cy="attribute-card"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center justify-between space-x-2 overflow-hidden">
        <lf-heading3 class="max-w-100">
          {{ currentAttribute?.name }}
        </lf-heading3>
        <div
          v-if="currentAttribute?.description"
          v-tooltip="currentAttribute.description"
        >
          <icon-base :icon="IconInfo" class="text-disabled-medium" />
        </div>
      </div>
      <div class="flex items-center justify-between">
        <operation-list
          v-if="currentAttribute?.type === CustomAttributeTypeOption.formula"
        />
      </div>
    </div>
    <div class="mt-4">
      <div class="min-h-60 rounded-sm border border-gray-200 p-2 text-base">
        <formula-sheet
          v-if="
            currentAttribute?.type === CustomAttributeTypeOption.formula &&
            currentAttribute?.content?.formula
          "
          :formula="currentAttribute?.content?.formula"
        />
        <div v-else>
          {{ $t("ATTRIBUTE_BUILDER.SUBMITTED_BY_API") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from "pinia";

import { CustomAttributeTypeOption } from "@/enums/customAttributes";
import { useAttributeBuilderStore } from "@/stores/customAttributeBuilder";

import OperationList from "@/components/customAttributes/OperationList.vue";
import FormulaSheet from "@/components/customAttributes/formula/FormulaSheet.vue";
import IconInfo from "@/components/icons/IconInfo.vue";
import LfHeading3 from "@/components/ui/text/LfHeading3.vue";

const attributeBuilderStore = useAttributeBuilderStore();
const { currentAttribute } = storeToRefs(attributeBuilderStore);
</script>
